import { BehaviorSubject, of, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import * as signalR from "@microsoft/signalr";
import { LifeQuotationEndpoint } from '@app/core/endpoints/life/life-quotation-endpoint.service';
import { AuthService } from '../auth/auth.service';
import { ApiResponse } from '@app/shared/models/Common/apiresponse.model';
import { environment } from '@env/environment';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';

@Injectable()
export class HubNotificationService {
	private readonly _hubNotifyUrl: string = `${environment.authorityUrl}` + `/healthHubNotification`;
	private notifications = new BehaviorSubject<any[]>([]);

	private hubConnection!: signalR.HubConnection;
	url_base: string;
	tenantId: number;
	userTenantCode: string;
	lifeRole: any;
	healthRole: any;
	groupName: string;

	constructor(
		private lifeQuotationEndpoint: LifeQuotationEndpoint,
		private authService: AuthService
	) {

		this.tenantId = this.authService.tenantId;
		this.userTenantCode = this.authService.tenantCode;
		this.lifeRole = this.authService.currentUser.roles.filter(item => environment.notify_lifeRoles.includes(item));
		if (this.lifeRole.length > 0) {
			this.lifeRole = this.lifeRole.map(item => item.replace(/\s+/g, '').toLowerCase());
			this.groupName = 'Life-' + this.authService.currentUser.entityId + '-' + this.lifeRole;
			this.healthRole = this.authService.currentUser.roles.filter(item => environment.notify_healthRoles.includes(item));
			this.startConnection();
			this.addListner();
		}
	}
	getNotifications() {
		return this.notifications.asObservable(); // Expose as Observable
	}

	public startConnection = () => {
		// Check if the connection exists and is connected

		if (this.hubConnection?.state === signalR.HubConnectionState.Connected) {
			console.log("Already connected.");
			return;
		}
		const token = this.authService.accessToken;
		this.hubConnection = new signalR.HubConnectionBuilder()
			.withUrl(`${this._hubNotifyUrl}?group_name=${encodeURIComponent(this.groupName)}`, {
				skipNegotiation: false,
				transport: signalR.HttpTransportType.ServerSentEvents,
				headers: {
					"Authorization": `Bearer ${token}`
				}
			})
			.configureLogging(signalR.LogLevel.Debug)
			.withAutomaticReconnect([0, 2000, 5000, 10000]) // Reconnect after 2s, 5s, 10s
			.build();

		this.hubConnection
			.start()
			.then(() => {
				console.log("Connection started successfully.");

			})
			.catch(err => console.error("Error while starting the connection: ", err));

		// Handle automatic reconnection attempts
		this.hubConnection.onreconnecting(error => {
			console.warn("Reconnecting...", error);
		});

		this.hubConnection.onreconnected(connectionId => {
			console.log("Reconnected with connectionId: ", connectionId);
			this.addListner(); // Re-add listeners after reconnection
		});

		this.hubConnection.onclose(error => {
			console.error("Connection closed. Retrying...", error);
			setTimeout(() => this.startConnection(), 5000); // Try reconnecting after 5 seconds
		});
	};

	public addListner = () => {

		this.hubConnection.on('ReceiveNotification', (notification) => {
			this.addNotification(notification);
		});

		this.hubConnection.on('Ping', (notification) => {
			console.log('Ping processed successfully:', notification);
		});
	}

	getHealthLifeNotificationsDataStore(): DataSource {
		return this.lifeQuotationEndpoint.getHealthLifeNotificationsDataStore<ApiResponse>(this.groupName);
	}
	// private
	addNotification(notification: any) {
		this.notifications.next([...this.notifications.value, notification]);
	}

	addHealthLifeNotification(notification: any): Observable<ApiResponse> {
		return this.lifeQuotationEndpoint.addHealthLifeNotification<ApiResponse>(notification);
	}
}
